import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initTelemetry, trackPageView } from "@/lib/telemetry";

// Records one page_view per route change, for app "easypeazy".
//
// EasyPeazy's own site sent nothing to the ecosystem's analytics, while AI
// Website Design and ChurchConnect have reported into lpl_events since July. So
// nobody could tell how many people reached easypeazy.site, from where, or how
// far they got. This closes that gap with the system the rest of the ecosystem
// already uses, so no dashboard switch is needed and the numbers are queryable.
//
// Keyed on pathname + search so a React strict-mode double mount, or a no-op
// navigation to the same URL, does not double count.
export default function PageViewTracker() {
  const location = useLocation();
  const last = useRef(null);

  useEffect(() => {
    initTelemetry({ app: "easypeazy" });
  }, []);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (last.current === key) return;
    last.current = key;
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
